var debounceTimer;
export default function debounce(func, delay) {
    return function () {
        var context = this;
        var args = arguments;
        debounceTimer && clearTimeout(debounceTimer);
        debounceTimer = global.setTimeout(function () {
            func === null || func === void 0 ? void 0 : func.apply(context, args);
        }, delay !== null && delay !== void 0 ? delay : 300);
        return debounceTimer;
    };
}
